import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Publications } from '../components/Publications';
export function BooksAndMedia() {
  return <>
      <PageHeader eyebrow="Books & Media" title="Three published works on leadership, history and national service." intro="Available for author interviews, panels and keynote programs through Worldwide Speakers Group." data-id="element-281" data-mp="1qvtomze131e5" />
      <Publications data-id="element-282" data-mp="24v1o7te3sbiv" />
    </>;
}